import React from 'react';
import PropTypes from 'prop-types';

// @atlaskit
import ArrowLeftIcon from '@atlaskit/icon/glyph/arrow-left';
import Button, { ButtonGroup } from '@atlaskit/button';
import ExcelSpreadsheetIcon from '@atlaskit/icon-file-type/glyph/excel-spreadsheet/48';
import Lozenge from '@atlaskit/lozenge';
import Tooltip from '@atlaskit/tooltip';
import SectionMessage from '@atlaskit/section-message';

// @source
import { File as API } from '../../../../server';
import * as Styled from '../styled';

const initialState = {
  isLoading: false,
  message: false,
};

class UploadTemplate extends React.Component {
  constructor(props) {
    super(props);
    this.extensions = ['xls', 'xlsx'];
    this.state = initialState;
    this.unmount = false;
    this.onSubmitHandle = this.onSubmitHandle.bind(this);
  }

  componentWillUnmount() {
    this.unmount = true;
  }

  onSubmitHandle() {
    this.setState({
      isLoading: true,
      message: false,
    });

    if (this.template.files.length) {
      const file = this.template.files[0];
      const extension = file.name.split('.');

      if (this.extensions.includes(extension[extension.length - 1])) {
        this.props.save(() => API.upload({
          data: {
            params: `reportname=${this.props.template}.xlsx`,
            files: file,
          },
          success: () => {
            this.props.setStep(2);
            this.setStateUnmount({ isLoading: false });
          },
        }));
      } else {
        this.setStateUnmount({
          isLoading: false,
          message: (
            <SectionMessage appearance="error">
              Please select a file in excel file format
            </SectionMessage>
          ),
        });
      }
    } else {
      this.props.save(() => {
        this.props.setStep(2);
      });
    }
  }

  setStateUnmount(state) {
    if (this.unmount) return;
    this.setState(state);
  }

  renderFileDropInfo() {
    if (this.template && this.template.files.length) {
      const { name } = this.template.files[0];
      return (
        <p>
          Scheme named
          <Lozenge appearance="success">{name}</Lozenge>
          {' '}
          has been selected.
        </p>
      );
    }
    return <p>Click here or drag and drop your template file here.</p>;
  }

  render() {
    return (
      <div style={{ display: this.props.current ? 'block' : 'none' }}>
        <Styled.UploadTemplate>
          <h3>Would you like to add a template?</h3>
          <Styled.FileDragArea>
            <input
              type="file"
              accept=".xlsx"
              ref={(node) => { this.template = node; }}
              onChange={() => this.setState({})}
            />
            <Styled.UploadFileIcon>
              <ExcelSpreadsheetIcon size="xlarge" />
              {this.renderFileDropInfo()}
            </Styled.UploadFileIcon>
          </Styled.FileDragArea>
          <div style={{ marginBottom: 10 }}>{this.state.message}</div>
          <p>
            Please select the template you want to upload, this template will be used in the report.
            <br />
            Your reports are presented with the selected template.
          </p>
          <br />
          <ButtonGroup>
            <Tooltip content="Previous step">
              <Button
                appearance="default"
                iconBefore={<ArrowLeftIcon size="medium" />}
                onClick={() => this.props.setStep(0)}
              />
            </Tooltip>
            <Button
              appearance="primary"
              isLoading={this.props.isLoading || this.state.isLoading}
              onClick={this.onSubmitHandle}
            >
              Save and Create
            </Button>
          </ButtonGroup>
        </Styled.UploadTemplate>
      </div>
    );
  }
}

UploadTemplate.propTypes = {
  current: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  save: PropTypes.func.isRequired,
  setStep: PropTypes.func.isRequired,
  template: PropTypes.string.isRequired,
  update: PropTypes.func.isRequired,
};

export default UploadTemplate;
